
export const getCorrectFilePath = (path, pathFile) => {
    if (path) {
       return typeof path === 'string' ? (path.includes('http') ? path : process.env.REACT_APP_PATH_FILE + path) : "";
    }
    return pathFile;
}